import { Locale } from "vue-i18n";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * I18n Web Storage service
 */
export abstract class I18nStorageService {
  private static i18nStorageKey = "i18n:locale";

  /**
   * Saves given locale to Web Storage
   * @param locale Locale id
   */
  static saveLocale(locale: Locale): void {
    localStorage.setItem(this.i18nStorageKey, locale);
  }

  /** Returns current locale saved in Web Storage */
  static get locale(): Locale {
    return localStorage.getItem(this.i18nStorageKey) as string;
  }
}
